<div class="bg-paper flex min-h-dvh">
  <app-sidebar
    [isOpen]="sidebarOpen()"
    (closeRequested)="closeSidebar()" />

  <div class="flex min-h-dvh min-w-0 flex-1 flex-col">
    <app-header (menuToggle)="toggleSidebar()" />

    <main class="flex-1 p-4 sm:p-6 lg:p-8">
      <router-outlet />
    </main>
  </div>

  <app-toast-tray />
</div>
